import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import EmployeeContext from '@/product/context/employee/empContext'
import ReportContext from '@/product/context/report/reportContext'
import { handleRedirectInternal } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import '../../Dashboard/Dashboard.css'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'

import EmployeeManage from '../usersView'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { v4 as uuidv4 } from 'uuid'

const AllAgencyUsers = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const employeeContext = useContext(EmployeeContext)
    const reportContext = useContext(ReportContext)
    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const history = useHistory()

    const { getAllExportDownload } = reportContext
    const {
        all_employees,
        changeUserStatus,
        getAllEmployees,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = employeeContext
    const { allAgencies } = customCommonContext
    const { user } = authContext

    const [changeStatus, setChangeStatus] = React.useState(false)
    const [existingEmpPopup, setExistingEmpPopup] = useState(false)
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [clearAutocomplete, setClearAutocomplete] = useState(false)
    const [existingEmployees, setExistingEmployees] = useState([])
    const [filteredAgencies, setFilteredAgencies] = useState([])
    const [filteredAgenciesDropdown, setFilteredAgenciesDropdown] = useState([])

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    const changeEmpPopupStatus = () => {
        setExistingEmpPopup(!existingEmpPopup)
    }
    useEffect(() => {
        return () => setIsLoading(false)
    }, [])
    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    let action = props?.custom
        ? null
        : props.match.params.action !== 'all'
        ? props.match.params.action
        : null

    const [tableBody, setTableBody] = useState([])
    const [newTableBody, setNewTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            agency: true,
            split_agencywise_emp: true,
            filters: {
                action: {
                    value: action ? action.toString() : 'all',
                    type: 'in',
                    field: 'u.status',
                },
                status: {
                    value: 'deleted',
                    type: 'notin',
                    field: 'e.emp_status',
                },
                emp_email: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_email',
                },
                emp_firstname: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_firstname',
                },
                emp_lastname: {
                    value: '',
                    type: 'like',
                    field: 'e.emp_lastname',
                },
                emp_type: {
                    value: 'seller',
                    type: 'notin',
                    field: 'e.emp_type',
                },
                emp_agencies: {
                    value: [],
                    type: 'findinarray',
                    field: 'ce.emp_agencies',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            console.log('i am getAllEmployees 0 - allEmpFilter')
            getAllEmployees(values, 'allEmpFilter')
        },
    })

    useEffect(() => {
        if (allAgencies && allAgencies.length) {
            let filteredPreAgencies = allAgencies.map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.agency_name
                subCategoryChanged.value = subcat.id
                return subCategoryChanged
            })

            let filteredPreAgenciesDropdown = allAgencies.map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.label = subcat.agency_name
                subCategoryChanged.value = subcat.id
                return subCategoryChanged
            })

            setFilteredAgenciesDropdown(filteredPreAgenciesDropdown)
            setFilteredAgencies(filteredPreAgencies)
        }
    }, [allAgencies, user, all_employees])

    console.log(filteredAgencies, 'filteredAgencies')

    useEffect(() => {
        if (all_employees) {
            console.log('i am getAllEmployees response - ', all_employees)
            if (
                all_employees.from === 'allEmpNoFilter' &&
                props.custom &&
                props?.agencyData?.id > 0
            ) {
                let existingEmps = []
                all_employees.records.length
                    ? all_employees.records
                          .filter(
                              (item) =>
                                  !item.emp_agencies?.includes(
                                      props?.agencyData?.id
                                  )
                          )
                          .map((item) => {
                              existingEmps.push({
                                  show: item.emp_email,
                                  value: item.id,
                              })
                          })
                    : []

                setExistingEmployees(existingEmps.length ? existingEmps : [])
            }
            if (all_employees.from === 'allEmpFilter') {
                setTableBody(
                    all_employees.records.length ? all_employees.records : []
                )
                setIsLoading(false)
            }
        }
    }, [all_employees])

    useEffect(() => {
        if (tableBody?.length) {
            let changeData = [...tableBody]
            changeData.map((value, index) => {
                if (value.id) {
                    value.uuid = uuidv4()
                }
            })
            setNewTableBody(changeData)
            console.log(changeData, 'table bodyyyyy')
        } else {
            setNewTableBody([])
        }
    }, [tableBody, all_employees])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1
        formik.values.filters.emp_email.value = ''
        formik.values.filters.emp_firstname.value = ''
        formik.values.filters.emp_lastname.value = ''

        props.custom && props?.agencyData?.id > 0 && existingEmpPopup === false
            ? (formik.values.filters.emp_agencies.value =
                  props?.agencyData?.id?.toString())
            : null

        console.log('i am getAllEmployees 1 - allEmpFilter')
        getAllEmployees(formik.values, 'allEmpFilter')
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    const onClickEdit = (id, type) => {
        // toggleFullScreenPopup(true, 'edit', id)
        handleRedirectInternal(history, `agency/users/edit/${id}`)
    }

    const onClickAgency = (id, type) => {
        handleRedirectInternal(history, `agency/view/${id}`)
    }
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            user_id: '',
        },
        onSubmit: (values) => {
            if (
                values.action === 'active' ||
                values.action === 'deactivate' ||
                values.action === 'deleted'
            ) {
                setIsLoading(true)
                changeUserStatus(values)
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.user_id = data
        console.log(data, 'after inclick')
        if (
            action === 'active' ||
            action === 'deactivate' ||
            action === 'deleted'
        ) {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Edit User',
            },
        ]
        return actionPush
    }

    const tableValues = [
        {
            field: 'emp_firstname',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Name',
            filterable: true,
            filterField: 'e.emp_firstname',
        },
        {
            field: 'emp_lastname',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Last Name',
            filterable: true,
            filterField: 'e.emp_lastname',
        },
        {
            field: 'emp_email',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Email',
            filterable: false,
            filterField: 'e.emp_email',
        },
        {
            field: 'agency_name',
            type: 'hyperlink',
            clickID: 'agency_id',
            sort: false,
            onclick: onClickAgency,
            firstChild: false,
            disablePadding: false,
            label: 'Agency',
            // filterable: true,
            // filterField: 'ce.emp_agencies',
            // valueOptions: filteredAgenciesDropdown, // If SingleSelect is given filter will work but the value is not showing.
        },
        {
            field: 'user_level',
            type: 'singleSelect',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'User Level',
            valueOptions: ['administrator', 'user', 'manager'],
            filterable: true,
            filterField: 'ce.user_level',
        },
        {
            field: 'emp_status',
            type: 'singleSelect',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
            valueOptions: ['active', 'deactivate'],
            filterable: true,
            filterField: 'e.emp_status',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Email',
                placeholder: 'Enter Email',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'emp_email',
                filter: true,
            },
            {
                label: 'First Name',
                placeholder: 'Enter First Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'emp_firstname',
                filter: true,
            },
            {
                label: 'Last Name',
                placeholder: 'Enter Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'emp_lastname',
                filter: true,
            },
            {
                label: 'Agency',
                type: 'autocomplete',
                placeholder: 'Select Agency',
                class: `col-sm-auto col-12`,
                name: 'emp_agencies',
                filter: true,
                multiple: true,
                size: 'small',
                options: filteredAgencies,
            },
        ],
    }

    const tableActions = []

    if (action === 'active') {
        tableActions.push({
            label: 'Move to De-activate',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactivate',
        })
    }
    if (action === 'deactivate') {
        tableActions.push({
            label: 'Move to Activate',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        })
    }

    if (action === 'all' || !action) {
        tableActions.push(
            {
                label: 'Move to De-activate',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
            },
            {
                label: 'Move to Activate',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            },
            {
                label: 'Move to Delete',
                icon: <span className="material-icons">delete</span>,
                onclick: onSelectMultiProducts,
                type: 'deleted',
            }
        )
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.status === 'success') {
                if (responseStatusUser.from === 'changeStatus') {
                    setChangeStatus(false)
                    console.log('i am getAllEmployees 2 - allEmpFilter')
                    props.custom &&
                    props?.agencyData?.id > 0 &&
                    existingEmpPopup === false
                        ? (formik.values.filters.emp_agencies.value =
                              props?.agencyData?.id?.toString())
                        : null
                    getAllEmployees(formik.values, 'allEmpFilter')
                    console.log(formik.values, 'changeStatus')
                }
                if (responseStatusUser.from === 'employeeAction') {
                    toggleFullScreenPopup(false)
                    console.log('i am getAllEmployees 3 - allEmpFilter')
                    props.custom &&
                    props?.agencyData?.id > 0 &&
                    existingEmpPopup === false
                        ? (formik.values.filters.emp_agencies.value =
                              props?.agencyData?.id?.toString())
                        : null
                    getAllEmployees(formik.values, 'allEmpFilter')
                    console.log(formik.values, 'employeeAction')
                }
            } else if (responseStatusUser.status === 'error') {
                if (responseStatusUser.from === 'employeeAction') {
                    toggleFullScreenPopup(false)
                }
            }
        }
    }, [responseStatusUser])

    const agencyFormik = useFormik({
        initialValues: {
            emp_ids: [],
            agency_id: props?.agencyData?.id,
            multiple: true,
            filters: {
                emp_ids: {
                    value: [],
                    type: 'array',
                    field: 'e.id',
                },
            },
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            if (values.filters.emp_ids.value.length && values.agency_id > 0) {
                let payload = {}
                payload['emp_ids'] = values.filters.emp_ids.value
                payload['agency_id'] = values.agency_id
                console.log('i am agency formik ', values, payload)
                return true
            }
        },
    })

    const existingAgencyFields = [
        {
            label: 'Existing Employee',
            placeholder: 'Add existing employee',
            class: 'col autoCptField',
            type: 'autocomplete',
            name: 'emp_ids',
            options: props.custom ? existingEmployees : [],
            filter: true,
            multiple: true,
            onClear: clearAutocomplete,
        },
    ]

    const handleExistingEmployeePopup = () => {
        formik.values.filters.emp_agencies.value = []
        console.log('i am getAllEmployees 4 - allEmpNoFilter')
        getAllEmployees(formik.values, 'allEmpNoFilter')
        setExistingEmpPopup(true)
    }

    return (
        <>
            {props?.custom ? (
                <>
                    <div className="dashboard employeeManagement">
                        <div className="miscActions d-flex justify-content-between align-items-center mt-4 flex-wrap">
                            <div>
                                {/* <Button
                                    id="employee_add"
                                    variant="outlined"
                                    className="btnOutlined mr-3"
                                    onClick={() =>
                                        toggleFullScreenPopup(true, 'new', 0)
                                    }
                                >
                                    <span className="material-icons">
                                        person_add_alt_1
                                    </span>
                                    Add New Employee
                                </Button> */}
                                {/* <Button
                                    id="employee_add_exist"
                                    variant="outlined"
                                    className="btnOutlined"
                                    onClick={() =>
                                        handleExistingEmployeePopup()
                                    }
                                >
                                    <span className="material-icons">
                                        person_add_alt_1
                                    </span>
                                    Add Existing Employee
                                </Button> */}
                            </div>
                        </div>
                        <CustomTable
                            formik={formik.values}
                            tableBody={newTableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={all_employees}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllEmployees}
                            fromVariable={'allEmpFilter'}
                            columnStorageVariable={'table_agency_user_manage'}
                        />
                    </div>

                    {/* <EmployeeManage
                        data={manage}
                        function={toggleFullScreenPopup}
                        custom={props?.custom}
                        agencyData={props?.agencyData}
                    /> */}
                    <CustomDialog
                        title={'Change user status'}
                        open={changeStatus}
                        function={changeChangeStatus}
                    >
                        <h5>Are you sure you want to change the status</h5>
                        <div className="actionWrapper">
                            <Button
                                id="employee_cancel"
                                onClick={() => changeChangeStatus()}
                            >
                                Cancel
                            </Button>
                            <form
                                onSubmit={formikSelection.handleSubmit}
                                autoComplete="nofill"
                            >
                                <PrimaryButton
                                    id="employee_confirm"
                                    type="submit"
                                    label="Confirm"
                                />
                            </form>
                        </div>
                    </CustomDialog>
                    <CustomDialog
                        title="Add Existing Employees"
                        className="addInfoModal"
                        open={existingEmpPopup}
                        function={changeEmpPopupStatus}
                    >
                        <div>
                            <form>
                                <div className="row">
                                    {mapData({
                                        formik: agencyFormik,
                                        data: existingAgencyFields,
                                    })}
                                </div>
                                <div className="btnWrpr mt-4">
                                    <SecondaryButton
                                        id="employee_cancel"
                                        onClick={() => changeEmpPopupStatus()}
                                        label="Cancel"
                                    />

                                    <PrimaryButton
                                        id="add_exist_emp"
                                        label="Add"
                                        onClick={agencyFormik.handleSubmit}
                                    />
                                </div>
                            </form>
                        </div>
                    </CustomDialog>
                </>
            ) : (
                <Layout>
                    <div className="dashboard employeeManagement">
                        <CustomSearch searchInfo={searchInfo} formik={formik} />
                        <div className="miscActions d-flex justify-content-between align-items-center mt-4 flex-wrap">
                            <div>
                                {/* <Button
                                    id="employee_add"
                                    variant="outlined"
                                    className="btnOutlined"
                                    onClick={() =>
                                        toggleFullScreenPopup(true, 'new', 0)
                                    }
                                >
                                    <span className="material-icons">
                                        person_add_alt_1
                                    </span>
                                    Add New Employee
                                </Button> */}
                            </div>
                            <Button
                                id="employee_report"
                                onClick={() =>
                                    getAllExportDownload({
                                        fields: [
                                            'emp_firstname',
                                            'emp_lastname',
                                            'emp_email',
                                            'emp_phone',
                                            'emp_address1',
                                            'emp_city',
                                            'emp_zip',
                                            'emp_state',
                                            'emp_country',
                                            'emp_type',
                                        ],
                                        action: 'export',
                                        isDefault: false,
                                        order: 'asc',
                                        orderby: '',
                                        search: 'all',
                                        report: `employee_list`,
                                        search_emp_type: 'agency',
                                    })
                                }
                            >
                                <span className="material-icons">get_app</span>
                                Export All Data
                            </Button>
                        </div>
                        <CustomTable
                            formik={formik.values}
                            tableBody={newTableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={all_employees}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllEmployees}
                            fromVariable={'allEmpFilter'}
                            diff_id={'uuid'}
                            columnStorageVariable={'table_agency_employee'}
                        />
                    </div>

                    <EmployeeManage
                        data={manage}
                        function={toggleFullScreenPopup}
                    />
                    <CustomDialog
                        title={'Change user status'}
                        open={changeStatus}
                        function={changeChangeStatus}
                    >
                        <h5>Are you sure you want to change the status</h5>
                        <div className="actionWrapper">
                            <Button
                                id="employee_cancel"
                                onClick={() => changeChangeStatus()}
                            >
                                Cancel
                            </Button>
                            <form
                                onSubmit={formikSelection.handleSubmit}
                                autoComplete="nofill"
                            >
                                <PrimaryButton
                                    id="employee_confirm"
                                    type="submit"
                                    label="Confirm"
                                />
                            </form>
                        </div>
                    </CustomDialog>
                </Layout>
            )}
        </>
    )
}

export default AllAgencyUsers
